module.exports = __webpack_public_path__ + "static/media/angry-emoji-emoticon-emoticons-expression-mad-svgrepo-com.7af43fa7.svg";